window.addEventListener( 'load', function() {
	var faqs = document.querySelectorAll('.faqs__item');

	faqs.forEach( function(faq) {
		var toggle = faq.querySelector('.faqs__item-toggle');
		var answer = faq.querySelector('.faqs__item-answer');
		var answerText = answer.querySelector('.faqs__item-answer-text');
		var answerHeight = answerText.offsetHeight;

		toggle.addEventListener('click', function() {
			this.classList.toggle('active');
			answer.classList.toggle('active');

			if (answer.classList.contains('active')) {
				answer.style.height = answerHeight + 'px';
			} else {
				answer.style.height = '0px';
			}
		});
	});
	
	var expandButtons = document.querySelectorAll('.expand-all');
	for (var i = 0; i < expandButtons.length; i++) {
		var button = expandButtons[i];
		button.addEventListener('click', function() {
			var currentButton = this;
			var toggles = this.parentElement.parentElement.querySelectorAll('.faqs__item-toggle');
			for (var i = 0; i < toggles.length; i++) {
				toggles[i].classList.toggle('active');
			}
			
			var answers = this.parentElement.parentElement.querySelectorAll('.faqs__item-answer');
			for (var i = 0; i < answers.length; i++) {
				var answerText = answers[i].querySelector('.faqs__item-answer-text');
				var answerHeight = answerText.offsetHeight;
				answers[i].classList.toggle('active');

				if (!currentButton.classList.contains('active')) {
					answers[i].style.height = answerHeight + 'px';
					answers[i].classList.add('active');
				} else {
					answers[i].style.height = '0px';
					answers[i].classList.remove('active');
				}
			}
			this.classList.toggle('active');
			
		});
	}
});